import { Workbox } from 'workbox-window';
import start from './shared';

if ('serviceWorker' in navigator) {
	const workbox = new Workbox('/service-worker.js');

	// force the SW to update assets on next page load
	workbox.addEventListener('waiting', () => {
		workbox.messageSW({ type: 'SKIP_WAITING' });
	});

	workbox.register();
}

start();
